import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';

import { ApiService } from '../../core/api.service';
import { TemplateList,TemplateListReq,SearchTemplateListReq } from '../model/TemplateList';

const MY_TEMPLATE_KEY = "template_list_my_template";

@Injectable({
  providedIn: 'root'
})
export class TemplateListService {
  myTemplate: string;

  constructor( private apiService: ApiService) {
  }

  public getTemplateList(req: TemplateListReq): Observable<TemplateList[]> {
  	let URL = "Apptool/GetTemplateList";
  	return this.apiService.get(URL, req);
  }

  public searchTemplateList(req: SearchTemplateListReq): Observable<TemplateList[]> {
  	let URL = "Apptool/SearchTemplateList";
  	return this.apiService.get(URL, req);
  }

  // Kept in sessionStorage, not just in memory: the template list itself is cached there
  // ("template_list", see TemplateService.cacheTemplateList) and survives a browser refresh, so
  // the 'My / Shared' choice must survive it too - otherwise after a refresh the radio falls back
  // to 'My Templates' while the cached shared list is still shown, with my-template permissions
  // (e.g. a view-only share's dropdown becomes editable).
  public getMyTemplate(): string {
    if (this.myTemplate === undefined) {
      this.myTemplate = sessionStorage.getItem(MY_TEMPLATE_KEY) ?? undefined;
    }
    if (this.myTemplate === undefined) return "1"; // display my template by default.
    return this.myTemplate;
  }

  public setMyTemplate(myTemplate: string): void {
    this.myTemplate = myTemplate;
    sessionStorage.setItem(MY_TEMPLATE_KEY, myTemplate);
  }
}